export const API_URL = "https://api.nokorshop.com";

export const TOKEN_LABEL = 'sastra-film-dashboard-token'
